import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class User extends Form {

    constructor(data = {}) {
        super(data);

        this.two_factor_loading = false;
        this.show_recovery_codes = false;
        this.code_2fa = null;
    }

    login() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/sanctum/csrf-cookie').then(cookie => {
                axios.post('/login', self.data).then(response => {
                    resolve(response);
                }).catch(error => {
                    self.setError(error);

                    reject(error);
                });
            });
        })
    }

    logout() {
        let self = this;

        return axios.post('/logout');
    }

    recoverAccount() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/recover', self.data).then(response => {

                self.setSuccessMessage('An email has been sent with instructions to recover your account.', false)
                self.setFormUpdateComplete();

                resolve(response);
            }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

    resetPassword() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/reset', self.data).then(response => {

                self.setSuccessMessage('Your password has been reset.', false)
                self.setFormUpdateComplete();

                resolve(response);
            }).catch(error => {
                let err = error.response.data;

                if (err.email) {
                    self.setError({
                        message: err.email
                    }, false);
                } else {
                    self.setError(error);
                }

                reject(error);
            });
        })
    }

    signUp() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.post('/api/signup', self.data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    accountInvite() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/account/invite', self.data)
                .then(response => {

                    self.setSuccessMessage('User Invited.')
                    self.setFormUpdateComplete();

                    self.data = {};

                    resolve(response);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    current() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/user/settings', self.data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    settings() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/user/settings?decimal=true&src=' + this.show_recovery_codes, self.data)
                .then(response => {

                    self.data = response.data.data;

                    resolve(response);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    updateSettings() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.patch('/api/user/settings?decimal=true', self.data)
                .then(response => {

                    self.data = response.data.data;

                    self.setSuccessMessage('Account settings updated.')
                    self.setFormUpdateComplete();

                    resolve(response);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    delete() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.delete('/api/user', self.data)
                .then(response => {

                    self.setFormUpdateComplete();

                    resolve(response);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    getAllAccountUsers() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/account/users', self.data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    deleteAccountUsers(id) {
        let self = this;

        return new Promise((resolve, reject) => {

            self.getAllAccountUsers().then(result => {
                axios.delete('/api/account/users/' + id, self.data)
                    .then(response => {
                        resolve(response.data.data);
                    })
                    .catch(error => {
                        self.setError(error);

                        reject(error);
                    })
            });
        });
    }

    resendAccountUserInvite(id) {
        let self = this;

        return new Promise((resolve, reject) => {

            self.getAllAccountUsers().then(() => {
                axios.get('/api/account/users/resend/invite/' + id, self.data)
                    .then(() => {
                        self.setSuccessMessage('Invite Sent')
                        resolve(true);
                    })
                    .catch(error => {
                        self.setError(error);
                        reject(error);
                    })
            });
        });
    }

    updateUserRole(user) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.patch('/api/user/' + user.id, {role: user.role})
                .then(() => {
                    self.setSuccessMessage('Role Updated!')
                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    enableTwoFactorAuthentication() {
        const url = '/user/two-factor-authentication';

        this.toggleTwoFactorLoading();

        axios.post(url)
            .then(() => {
                this.settings().then(() => this.toggleTwoFactorLoading())
            })
            .catch(e => {
                this.setError(e)
                this.toggleTwoFactorLoading()
            });
    }

    disableTwoFactorAuthentication() {
        const url = '/user/two-factor-authentication';

        this.toggleTwoFactorLoading();

        axios.delete(url)
            .then(() => {
                this.data.two_factor.enabled = false;

                this.toggleTwoFactorLoading();
            })
            .catch(e => {
                this.setError(e)
                this.toggleTwoFactorLoading()
            });
    }

    checkTwoFactorAuthentication() {
        const url = '/api/user/check-two-factor';

        this.resetFormMessages().then(() => {
            this.toggleTwoFactorLoading();
        });

        axios.post(url, {
            code: this.code_2fa
        }).then((response) => {
            this.show_recovery_codes = true;

            this.settings().then(() => this.toggleTwoFactorLoading())
        })
        .catch(e => {
            this.setError(e)
            this.toggleTwoFactorLoading()
        });
    }

    showRecoveryCodes() {
        this.show_recovery_codes = true;

        this.settings().catch(e => this.setError(e));
    }

    regenerateRecoveryCodes() {
        const url = '/user/two-factor-recovery-codes ';

        this.resetFormMessages().then(() => {
            this.toggleTwoFactorLoading();
        });

        axios.post(url).then((response) => {
            this.show_recovery_codes = true;

            this.settings().then(() => this.toggleTwoFactorLoading())
        }).catch(e => {
            this.setError(e)
            this.toggleTwoFactorLoading()
        });
    }

    hideRecoveryCodes() {
        this.show_recovery_codes = false;
    }

    toggleTwoFactorLoading() {
        this.two_factor_loading = ! this.two_factor_loading;
    }

}
